import React, { useEffect, useState } from "react"
import T from "../T/T";
import "./styles.scss";

export default function ErrorMessage() {
  const [content, setContent] = useState("")

  useEffect(() => {
    const urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;

    if (urlParams && urlParams.get("content")) {
      setContent(urlParams.get("content"));
    } else {
      setContent((<T>error-title</T>));
    }
  }, [])

  return (
    <div className="error-message-content">
      <p className="errorMessage">{content}</p>

      <div className="contact-us-button">
        <a href="mailto:deweyclothing@help.xela.co">
          <T>contact-us-button</T>
        </a>
      </div>
    </div>
  )
}
